import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getSwapStatuses, saveBatchSwapStatuses } from '../../api/swapStatuses';
import type { SwapStatus } from '../../types/SwapStatus';
import { t } from '../../i18n/t';

const columnDefs: ColDef<SwapStatus>[] = [
  {
    field: 'swapStatusId',
    headerName: t('swapStatuses.columns.swapStatusId'),
    width: 140,
    cellDataType: 'number',
    editable: (p: EditableCallbackParams<SwapStatus>) =>
      (p.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'swapStatusName', headerName: t('swapStatuses.columns.swapStatusName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<SwapStatus> => ({ swapStatusId: 0, swapStatusName: '' });

export function SwapStatusesPage() {
  return (
    <LopCrudPage<SwapStatus>
      resourceCode="swapStatuses"
      titleKey="swapStatuses.pageTitle"
      idField="swapStatusId"
      getRows={getSwapStatuses}
      saveBatch={(added, modified, deletedIds) => saveBatchSwapStatuses(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
